import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-encashment-rec-form',
  templateUrl: './leave-encashment-rec-form.component.html',
  styleUrls: ['./leave-encashment-rec-form.component.css']
})
export class LeaveEncashmentRecFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-form/leave-encashment-rec-form.component.ts